<template>
    <v-dialog
        v-if="visible"
        v-model="visible"
        transition="dialog-top-transition"
        scrollable
        persistent
        max-width="600"
    >
        <v-card class="modal-maincard">

            <v-toolbar dark flat dense>
                <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="wrapperFormModal">
                <v-card 
                    flat
                >
                    <v-card-text>

                        <v-row no-gutters>

                            <v-col cols="12" sm="12" md="3">
                                <label class="f-label">
                                    {{ $t("Причина") }}
                                </label>
                            </v-col>

                            <v-col cols="12" sm="12" md="9">
                                <v-textarea
                                    v-model="subject"
                                    rows="3"
                                    no-resize
                                    hide-details
                                    required
                                    outlined
                                    dense
                                    :rules="requiredRule"
                                >
                                </v-textarea>
                            </v-col>

                        </v-row>

                        <v-row no-gutters>
                            <v-col cols="12" sm="12" md="3">
                                <label class="f-label">{{$t("Запрашиваемый срок")}}</label>
                            </v-col>

                            <v-col cols="12" sm="12" md="9">
                                <v-menu 
                                    v-model="controlDateMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            :value="controlDate | formattedDate"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            outlined
                                            dense
                                            class="datepick-input"
                                            required
                                            :rules="requiredRule"
                                            hide-details
                                        >
                                        </v-text-field>
                                    </template>

                                    <v-date-picker
                                        v-model="controlDate"
                                        @input="controlDateMenu = false"
                                        color="teal"
                                        :min="minDate"
                                        :first-day-of-week="1"
                                    >
                                    </v-date-picker>
                                </v-menu>

                            </v-col>

                        </v-row>

                        <v-row no-gutters>

                            <v-col cols="12" sm="12" md="3">
                                <label class="f-label">
                                    {{ $t("Вложения") }}
                                </label>
                            </v-col>

                            <v-col cols="12" sm="12" md="9">
                                <div class="icon-click-row-group">
                                    <div @click="$refs.fileInputRef.click()">
                                        <input
                                            type="file"
                                            ref="fileInputRef"
                                            @change="onFileChanged"
                                            multiple
                                            style="display: none"
                                        />
                                        <v-icon small>
                                            fas fa-edit
                                        </v-icon>
                                    </div>

                                    <div class="cloud-file-list-box">
                                        <div class="cloud-items-container">

                                            <div v-if="!attachments" class="cfl-placeholder">{{ $t('Нет_файлов') }}</div>

                                            <v-row 
                                                v-else
                                                dense
                                            >
                                                <v-file-item
                                                    v-for="(attachment, index) in attachments"
                                                    :key="index"
                                                    :name="attachment.name"
                                                    :size="attachment.size"
                                                    col-width="12"
                                                    :hide-load="true"
                                                    @on-delete-attachment="onDeleteAttachment(index)"
                                                />
                                            </v-row>

                                        </div>
                                    </div>
                                </div>
                            </v-col>

                        </v-row>

                    </v-card-text>

                </v-card>

            </v-card-text>

            <v-card-actions>

                <v-spacer></v-spacer>

                <v-btn 
                    color="cyan"
                    text
                    depressed
                    @click="ok"
                    v-if="!!subject && !!controlDate"
                >
                    {{ $t("Отправить") }} 
                </v-btn>

                <v-btn
                    color="blue-grey"
                    text
                    depressed
                    @click="cancel"
                >
                    {{ $t("Отмена") }}
                </v-btn>

            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import i18n from '@/i18n'
import sys from '@/services/system';

export default {
    name: "SendRequestExtensionDlg",
    data () {
        return {
            title: "Запрос_на_продление",
            options: {
                color: 'grey lighten-3',
                width: 400,
                zIndex: 200,
                noconfirm: false,
            },
            controlDateMenu: false
        }
    },
    filters: {
        formattedDate: function (value) {
            var formatedDate = sys.dateFormat(value, 'DD.MM.YYYY');
            return formatedDate ?? "";
        }
    },
    computed: {
        ...mapGetters('global/dialogs/sendRequestExtension',{ visible: 'isVisible', attachments: 'getAttachments' }),
        ...mapGetters({ requiredRule: 'getRequiredRule'}),
        subject: {
            get: function() {
                return this.$store.getters['global/dialogs/sendRequestExtension/getSubject'];
            },
            set: function(v) {
                this.$store.commit('global/dialogs/sendRequestExtension/SET_SUBJECT', v);
            }
        },
        controlDate: {
            get: function() {
                return this.$store.getters['global/dialogs/sendRequestExtension/getDate'];
            },
            set: function(v) {
                this.$store.commit('global/dialogs/sendRequestExtension/SET_DATE', v);
            }
        },
        minDate(){
            return this.$store.getters['global/dialogs/sendRequestExtension/getMinDate'];
        },
        selectAttachmentTooltip() {
            return i18n.t("Выбрать_вложение");
        }
    },
    methods: {
        ...mapActions('global/dialogs/sendRequestExtension', ['ok', 'cancel']),
        ...mapActions('global/attachments', ['validateFile']),
        onFileChanged(event) {
            let files = Array.from(event.target.files);

            if (files && files.length > 0) {
                if (this.attachments.length + files.length > 3){
                    this.$notify.alert(i18n.t("Превышен_лимит_вложений"));
                }
                else {
                    files.forEach(file => {
                        this.validateFile(file)
                            .then(checkResult => {
                                
                                if (!checkResult.success) {
                                    this.$notify.alert(i18n.t('Ошибка_загрузки_файла:_filename_with_reason.message', { filename: file.name, reason: checkResult.message }));
                                    event.target.value = '';
                                    return;
                                }
                                this.$store.commit('global/dialogs/sendRequestExtension/PUSH_ATTACHMENT', file);
                            });
                    });
                }
            }
            event.target.value = '';
        },
        onDeleteAttachment(index){
            this.$store.commit('global/dialogs/sendRequestExtension/DEL_ATTACHMENT', index);
        }
    }
}
</script>